
/* styles */
require("!!../node_modules/.1.0.1@extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../node_modules/.10.3.0@vue-loader/lib/style-rewriter?id=data-v-5245bdf4!sass-loader?sourceMap!../node_modules/.10.3.0@vue-loader/lib/selector?type=styles&index=0!./app.vue")

var Component = require("!../node_modules/.10.3.0@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../node_modules/.10.3.0@vue-loader/lib/selector?type=script&index=0!./app.vue"),
  /* template */
  require("!!../node_modules/.10.3.0@vue-loader/lib/template-compiler?id=data-v-5245bdf4!../node_modules/.10.3.0@vue-loader/lib/selector?type=template&index=0!./app.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app.vue
// module id = 209
// module chunks = 22